import React, {Component} from 'react';

import './main.css'

import * as one from '../assets/images/onboarding mock.png';
import * as two from '../assets/images/reminders mock.png';
import * as three from '../assets/images/brain mock.png';
import * as four from '../assets/images/dark mock.png';
import * as vid from '../assets/video/video.mp4';
import * as Test2 from '../assets/images/light.png';

class Main extends Component {
  render() {
    return (
      <div className='pageWrapper'>
        <div className='spacer'/>
        <div className='sspacer'/>
        <div className='s1Wrapper'>
          <h1 className='s1Text'>
            Driving is dangerous. With so many visual cues to take in, it's easy to miss some of them. Humans have more senses than just sight so why not put them to use when driving? 
          </h1>
        </div>
        <div className='spacer'/>
        <div className='s2Wrapper'>
          <h1 className='s2Text gridLeft'>
            DASH is a driving assistant for anyone on the road.
          </h1>
          <img className='mockup gridRight' src={one} alt='Mockup'/>
        </div>
        <div className='spacer'/>
        <div className='s2Wrapper'>
          <h1 className='s2Text gridRight'>
            Remind yourself of important safety practices before you drive.
          </h1>
          <img className='mockup gridLeft' src={two} alt='Mockup'/>
        </div>
        <div className='spacer'/>
        <div className='s2Wrapper'>
          <h1 className='s2Text gridLeft'>
            Get audible warnings for traffic signals as you drive.
          </h1>
          <img className='mockup gridRight' src={three} alt='Mockup'/>
        </div>
        <div className='spacer'/>
        <div className='s2Wrapper'>
          <h1 className='s2Text gridRight'>
            Automatically toggle dark mode when the sun sets.
          </h1>
          <img className='mockup gridLeft' src={four} alt='Mockup'/>
        </div>
        <div className='spacer'/>
        <video className='demoVideo' src={vid} controls={true}/>
        <div className='spacer'/>
        <div className='s3Wrapper'>
          <h1 className='s3Text'>
            So how does it work?
          </h1>
        </div>
        <div className='sspacer'/>
        <img className='light' src={Test2} alt='Mockup'/>
        <div className='sspacer'/>
        <div className='s4Wrapper'>
          <h1 className='s4Text'>
            Live camera feed from your device is analyzed by an object recognition model built on TeachableMachine. The model then relays its conclusions to the driver if it is more than 90% confident in its conclusion. Basically, if your camera feed picks up a green light, your phone will announce "green light ahead!".
          </h1>
        </div>
        <div className='sspacer'/>
        <div className='s5Wrapper'>
          <h1 className='s5Text'>
            It's similar to what autonomous cars do except it doesn't actually drive your car... and this app was made by a high school student... In other words, DON'T BET YOUR LIFE ON THIS APP.
          </h1>
        </div>
        <div className='spacer'>
          <div className='mlogButton' onMouseDown={() => window.open('https://docs.google.com/document/d/1uXt_dO6zHyIOvsupBueB5VCvcKp1sQ70hzoEgauem88/edit?usp=sharing')}>View Devlog</div>
        </div>
      </div>
    );
  }
}

export default Main;